import { FigmaFileStructureNodeImportModel } from "../import/figma-frames";
import { z } from "zod";
export const FigmaNodeStructureDataV2 = z.object({
    rootNode: FigmaFileStructureNodeImportModel,
    assetsInFile: z.object({
        components: z.number(),
        componentSets: z.number(),
        frames: z.number(),
    }),
});
